import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_RED } from "../../config/constants";

const Connector11ARed11BBlack = ({ state, workState }) => (
	<g id="Connector11ARed11BBlack" transform="translate(2117.616760, 440.003971)">
		<line
			x1="165.917482" y1="-3.58964951" x2="161.811287" y2="24.1005616" id="Path-"
			strokeLinecap="round"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
      strokeWidth={tracksWidth}
      transform="translate(163.864385, 10.255456) rotate(55.000000) translate(-163.864385, -10.255456) "/>
	</g>
);

export default Connector11ARed11BBlack;
